import React from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LEGAL_PATHS } from "../../../../Components/Auth/Legal/legalRules";

// The old /Privacypolicy route: the Privacy Policy has its own page now, in French
// (/confidentialite) and in English (/privacy). This sends old links and bookmarks to
// the one in the reader's language.
function Privacypolicy() {
  const { i18n } = useTranslation();
  const lang = i18n.resolvedLanguage === "fr" ? "fr" : "en";
  return <Navigate to={LEGAL_PATHS.privacy[lang]} replace />;
}

export default Privacypolicy;
